import { CancellablePromise, get } from "@/api";
import type { DictionaryGroup } from "@/types";

export function getDictionaryGroups(): CancellablePromise<DictionaryGroup[]> {
  return get<DictionaryGroup[]>("/v1/dictionary-groups");
}
